"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var theme_1 = require("../../utils/theme");
var Status = (function (_super) {
    tslib_1.__extends(Status, _super);
    function Status() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, message = _b.message, size = _b.size, children = _b.children, visible = _b.visible, zIndex = _b.zIndex;
            var cls = classNames(prefixCls, className, prefixCls + "-" + size, prefixCls + "-" + (children ? 'attached' : 'fixed'), (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a));
            if (children) {
                return (h("div", { className: classNames(prefixCls + "-container") },
                    h("div", null, children),
                    h("div", { className: cls, style: style }, message)));
            }
            return react_dom_1.default.createPortal(h("div", { className: cls, style: tslib_1.__assign({ zIndex: zIndex }, style) }, message), document.body);
        };
        return _this;
    }
    Status.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Status;
}(React.Component));
exports.default = Status;
Status.defaultProps = {
    prefixCls: 'dui-status',
    size: 'small'
};
Status.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    message: PropTypes.string,
    size: PropTypes.oneOf(['small', 'big']),
    visible: PropTypes.bool,
    zIndex: PropTypes.number
};
